export default __webpack_public_path__ + "static/media/ttaQualifiedBadge.bba75bd8.svg";